import axios from "axios";
import { API_ROUTES } from "../../constants/API_ROUTES";

export default {
  logIn: async (email, password) => {
    try {
      const res = await fetch(API_ROUTES.ADMIN_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log(data);
      return data;
    } catch (error) {
      console.log(error);
      return;
    }
  },
  userLogin: async (email, password) => {
    try {
      const res = await fetch(API_ROUTES.USER_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log(data);
      return data;
    } catch (error) {
      console.log(error);
      return;
    }
  },
  verifyToken: async (token) => {
    try {
      const res = await fetch(API_ROUTES.VERIFY_TOKEN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      console.log(data);
      return data;
    } catch (error) {
      console.log(error);
      return;
    }
  },
  register: async (email, password) => {},
};
